export const META_START = "META_START";
export const META_FAIL = "META_FAIL";
export const GET_META = "GET_META";
export const GET_META_SUCCESS = "GET_META_SUCCESS";
